import * as React from "react";
const SvgFiRrShoePrints = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shoe-prints_svg__a)">
      <path
        fill="#062147"
        d="M18 2c-2.408 0-5 2.19-5 7 0 1.736.816 3.369 1.605 4.947C15.322 15.381 16 16.736 16 18v2.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5V18c0-1.377.229-2.291.47-3.257.261-1.042.53-2.12.53-3.743 0-7.383-4.331-9-6-9m3 18.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5V19h3zm.53-6.243c-.203.812-.412 1.646-.494 2.743h-3.123c-.23-1.368-.883-2.675-1.519-3.947-.717-1.434-1.395-2.789-1.395-4.053 0-3.283 1.509-5 3-5 .04 0 4 .19 4 7 0 1.377-.229 2.291-.47 3.257zM6 0C4.331 0 0 1.617 0 9c0 1.623.27 2.701.53 3.743.241.967.47 1.88.47 3.257v2.5C1 20.43 2.57 22 4.5 22S8 20.43 8 18.5V16c0-1.264.678-2.619 1.395-4.053C10.184 10.368 11 8.736 11 7c0-4.81-2.592-7-5-7m0 18.5c0 .827-.673 1.5-1.5 1.5S3 19.327 3 18.5V17h3zm1.605-7.447C6.969 12.325 6.316 13.632 6.086 15H2.964c-.082-1.097-.291-1.931-.494-2.743C2.229 11.29 2 10.377 2 9c0-6.81 3.96-7 4-7 1.491 0 3 1.717 3 5 0 1.264-.678 2.619-1.395 4.053"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shoe-prints_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShoePrints;
